/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Notetaker_TitleInputs */



/**
* | output |
* | --- |
* | "Report" |
*
* @param {Meetings_Notetaker_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_notetaker_title = /** @type {((inputs?: Meetings_Notetaker_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Notetaker_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verslag")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compte rendu")
	return /** @type {LocalizedString} */ ("Report")
});